import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import DataTable from '../components/DataTable';

function ExchangePage() {
  const [currencies, setCurrencies] = useState([]);
  const [rates, setRates] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().substring(0,10));
  const [loading, setLoading] = useState(false);
  const [tcmbLoading, setTcmbLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [showAddCurrency, setShowAddCurrency] = useState(false);
  const [showAddRate, setShowAddRate] = useState(false);
  const [newCurrency, setNewCurrency] = useState({ code:'', name:'', symbol:'' });
  const [newRate, setNewRate] = useState({ rate_date: new Date().toISOString().substring(0,10), currency_code:'', buying_rate:'', selling_rate:'', mid_rate:'', notes:'' });
  const [activeTab, setActiveTab] = useState('rates'); // 'rates' | 'currencies'
  const [filterDate, setFilterDate] = useState(new Date().toISOString().substring(0,10));
  const [filterCurrency, setFilterCurrency] = useState('');

  const fetchCurrencies = useCallback(async () => {
    try {
      const r = await api.get('/exchange/currencies');
      if (r.data.success) setCurrencies(r.data.data);
    } catch(e) { console.error(e); }
  }, []);

  const fetchRates = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterDate) params.date = filterDate;
      if (filterCurrency) params.currency_code = filterCurrency;
      const r = await api.get('/exchange/rates', { params });
      if (r.data.success) setRates(r.data.data);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [filterDate, filterCurrency]);

  useEffect(() => { fetchCurrencies(); }, [fetchCurrencies]);
  useEffect(() => { fetchRates(); }, [fetchRates]);

  const handleTcmb = async () => {
    setTcmbLoading(true); setMsg(null);
    try {
      const r = await api.post('/exchange/rates/fetch-tcmb', { date: filterDate });
      if (r.data.success) {
        setMsg({ type:'success', text: r.data.message });
        fetchRates();
      } else {
        setMsg({ type:'error', text: r.data.message });
      }
    } catch(e) { setMsg({ type:'error', text: 'TCMB baglanti hatasi' }); }
    finally { setTcmbLoading(false); }
  };

  const handleSaveRate = async () => {
    if (!newRate.currency_code || !newRate.buying_rate) {
      setMsg({ type:'error', text:'Döviz ve alis kuru zorunludur' }); return;
    }
    try {
      const r = await api.post('/exchange/rates', {
        ...newRate,
        mid_rate: newRate.mid_rate || ((parseFloat(newRate.buying_rate)+parseFloat(newRate.selling_rate||newRate.buying_rate))/2)
      });
      if (r.data.success) {
        setMsg({ type:'success', text:'Kur kaydedildi' });
        setShowAddRate(false);
        setNewRate({ rate_date: filterDate, currency_code:'', buying_rate:'', selling_rate:'', mid_rate:'', notes:'' });
        fetchRates();
      }
    } catch(e) { setMsg({ type:'error', text: e.response?.data?.message||'Hata' }); }
  };

  const handleSaveCurrency = async () => {
    if (!newCurrency.code || !newCurrency.name) {
      setMsg({ type:'error', text:'Kod ve ad zorunludur' }); return;
    }
    try {
      const r = await api.post('/exchange/currencies', newCurrency);
      if (r.data.success) {
        setMsg({ type:'success', text:'Para birimi eklendi' });
        setShowAddCurrency(false);
        setNewCurrency({ code:'', name:'', symbol:'' });
        fetchCurrencies();
      }
    } catch(e) { setMsg({ type:'error', text: e.response?.data?.message||'Hata' }); }
  };

  const handleDeleteRate = async (id) => {
    if (!window.confirm('Bu kur kaydini silmek istiyor musunuz?')) return;
    try {
      await api.delete('/exchange/rates/'+id);
      fetchRates();
    } catch(e) { setMsg({ type:'error', text:'Silme hatasi' }); }
  };

  const iStyle = { padding:'7px 10px', background:'var(--bg-input)', border:'1px solid var(--border-input)', borderRadius:8, color:'var(--text-primary)', fontSize:'0.82rem', width:'100%', boxSizing:'border-box' };

  return (
    <div style={{padding:20,maxWidth:1200,margin:'0 auto'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div>
          <h1 style={{margin:0,fontSize:'1.4rem',fontWeight:700}}>Para Birimleri & Kur Takibi</h1>
          <p style={{margin:'4px 0 0',color:'var(--text-secondary)',fontSize:'0.85rem'}}>Para birimi tanimlari ve gunluk kur gecmisi</p>
        </div>
      </div>

      {msg && <div className={'detail-msg '+msg.type} style={{marginBottom:12}}>{msg.text}</div>}

      {/* Tab bar */}
      <div style={{display:'flex',gap:4,marginBottom:16,borderBottom:'2px solid var(--border-secondary)'}}>
        {[['rates','Kur Gecmisi'],['currencies','Para Birimleri']].map(([k,l])=>(
          <button key={k} onClick={()=>setActiveTab(k)} style={{padding:'8px 18px',background:'none',border:'none',borderBottom: activeTab===k?'2px solid var(--accent-primary)':'2px solid transparent',color:activeTab===k?'var(--accent-primary)':'var(--text-secondary)',fontWeight:activeTab===k?600:400,cursor:'pointer',fontSize:'0.9rem',marginBottom:-2}}>{l}</button>
        ))}
      </div>

      {/* KUR GECMİSİ */}
      {activeTab==='rates'&&(
        <div>
          {/* Filtreler */}
          <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap',alignItems:'flex-end'}}>
            <div>
              <label style={{display:'block',fontSize:'0.78rem',color:'var(--text-tertiary)',marginBottom:4}}>Tarih</label>
              <input type="date" value={filterDate} onChange={e=>setFilterDate(e.target.value)} style={{...iStyle,width:160}}/>
            </div>
            <div>
              <label style={{display:'block',fontSize:'0.78rem',color:'var(--text-tertiary)',marginBottom:4}}>Döviz</label>
              <select value={filterCurrency} onChange={e=>setFilterCurrency(e.target.value)} style={{...iStyle,width:120}}>
                <option value="">Tümü</option>
                {currencies.filter(c=>!c.is_local).map(c=><option key={c.id} value={c.code}>{c.code}</option>)}
              </select>
            </div>
            <button onClick={handleTcmb} disabled={tcmbLoading} style={{padding:'8px 16px',background:'rgba(16,185,129,0.1)',color:'var(--success)',border:'1px solid var(--success)',borderRadius:8,cursor:'pointer',fontSize:'0.85rem',fontWeight:600}}>
              {tcmbLoading ? 'Cekiliyor...' : '↓ TCMB den Cek'}
            </button>
            <button onClick={()=>{setShowAddRate(true);setNewRate({rate_date:filterDate,currency_code:'',buying_rate:'',selling_rate:'',mid_rate:'',notes:''});}} style={{padding:'8px 16px',background:'var(--accent-primary)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',fontSize:'0.85rem',fontWeight:600}}>
              + Manuel Kur Ekle
            </button>
          </div>

          {/* Manuel kur formu */}
          {showAddRate&&(
            <div style={{background:'var(--bg-card)',border:'1px solid var(--border-secondary)',borderRadius:12,padding:16,marginBottom:16}}>
              <h3 style={{margin:'0 0 12px',fontSize:'0.95rem'}}>Yeni Kur Girişi</h3>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))',gap:10}}>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Tarih</label><input type="date" value={newRate.rate_date} onChange={e=>setNewRate(p=>({...p,rate_date:e.target.value}))} style={iStyle}/></div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Döviz *</label>
                  <select value={newRate.currency_code} onChange={e=>setNewRate(p=>({...p,currency_code:e.target.value}))} style={iStyle}>
                    <option value="">Secin</option>
                    {currencies.filter(c=>!c.is_local).map(c=><option key={c.id} value={c.code}>{c.code} - {c.name}</option>)}
                  </select>
                </div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Alis Kuru *</label><input type="number" step="0.0001" value={newRate.buying_rate} onChange={e=>setNewRate(p=>({...p,buying_rate:e.target.value}))} style={iStyle}/></div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Satış Kuru</label><input type="number" step="0.0001" value={newRate.selling_rate} onChange={e=>setNewRate(p=>({...p,selling_rate:e.target.value}))} style={iStyle}/></div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Orta Kur</label><input type="number" step="0.0001" value={newRate.mid_rate} placeholder="Oto hesap" onChange={e=>setNewRate(p=>({...p,mid_rate:e.target.value}))} style={iStyle}/></div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Not</label><input value={newRate.notes} onChange={e=>setNewRate(p=>({...p,notes:e.target.value}))} style={iStyle}/></div>
              </div>
              <div style={{marginTop:12,display:'flex',gap:8}}>
                <button onClick={handleSaveRate} style={{padding:'7px 18px',background:'var(--accent-primary)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',fontWeight:600}}>Kaydet</button>
                <button onClick={()=>setShowAddRate(false)} style={{padding:'7px 18px',background:'none',border:'1px solid var(--border-secondary)',borderRadius:8,cursor:'pointer',color:'var(--text-secondary)'}}>İptal</button>
              </div>
            </div>
          )}

          {/* Kur tablosu */}
          <DataTable
            pageKey="exchange-rates-list"
            loading={loading}
            emptyText="Bu tarih için kur bulunamadı. TCMB'den çekin veya manuel girin."
            data={rates}
            rowKey="id"
            columns={[
              { id: 'rate_date', header: 'Tarih', accessor: r => r.rate_date?.substring(0,10) || '', sortable: true, width: 110,
                cell: r => <span style={{fontFamily:'monospace',fontSize:'0.82rem'}}>{r.rate_date?.substring(0,10)}</span> },
              { id: 'currency', header: 'Döviz', accessor: 'currency_code', sortable: true, width: 90,
                cell: r => <span style={{fontWeight:700,color:'var(--accent-primary)'}}>{r.currency_code}</span> },
              { id: 'buying', header: 'Alış', accessor: r => parseFloat(r.buying_rate)||0, sortable: true, width: 110,
                headerStyle: {textAlign:'right'}, cellStyle: {textAlign:'right',fontWeight:600},
                cell: r => Number(r.buying_rate).toLocaleString('tr-TR',{minimumFractionDigits:4}) },
              { id: 'selling', header: 'Satış', accessor: r => parseFloat(r.selling_rate)||0, sortable: true, width: 110,
                headerStyle: {textAlign:'right'}, cellStyle: {textAlign:'right',fontWeight:600},
                cell: r => Number(r.selling_rate).toLocaleString('tr-TR',{minimumFractionDigits:4}) },
              { id: 'mid', header: 'Orta', accessor: r => parseFloat(r.mid_rate)||0, sortable: true, width: 110,
                headerStyle: {textAlign:'right'}, cellStyle: {textAlign:'right',color:'var(--text-secondary)'},
                cell: r => Number(r.mid_rate).toLocaleString('tr-TR',{minimumFractionDigits:4}) },
              { id: 'source', header: 'Kaynak', accessor: 'source', sortable: true, width: 100,
                headerStyle: {textAlign:'center'}, cellStyle: {textAlign:'center'},
                cell: r => <span style={{fontSize:'0.72rem',padding:'2px 8px',borderRadius:4,background:r.source==='tcmb'?'rgba(16,185,129,0.1)':'rgba(245,158,11,0.1)',color:r.source==='tcmb'?'var(--success)':'var(--warning,#f59e0b)'}}>{r.source==='tcmb'?'TCMB':'Manuel'}</span> },
              { id: 'notes', header: 'Not', accessor: 'notes', sortable: true,
                cell: r => <span style={{color:'var(--text-secondary)',fontSize:'0.8rem'}}>{r.notes||'-'}</span> },
              { id: 'delete', header: '', sortable: false, hideable: false, draggable: false, filterable: false, width: 40,
                cell: r => <button onClick={(e)=>{e.stopPropagation();handleDeleteRate(r.id);}} style={{background:'none',border:'none',color:'var(--danger)',cursor:'pointer',fontSize:'0.9rem'}}>×</button> },
            ]}
          />
        </div>
      )}

      {/* PARA BİRİMLERİ */}
      {activeTab==='currencies'&&(
        <div>
          <div style={{marginBottom:14}}>
            <button onClick={()=>setShowAddCurrency(true)} style={{padding:'8px 16px',background:'var(--accent-primary)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',fontSize:'0.85rem',fontWeight:600}}>+ Para Birimi Ekle</button>
          </div>

          {showAddCurrency&&(
            <div style={{background:'var(--bg-card)',border:'1px solid var(--border-secondary)',borderRadius:12,padding:16,marginBottom:16}}>
              <h3 style={{margin:'0 0 12px',fontSize:'0.95rem'}}>Yeni Para Birimi</h3>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))',gap:10}}>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Kod * (ornek: USD)</label><input value={newCurrency.code} onChange={e=>setNewCurrency(p=>({...p,code:e.target.value.toUpperCase()}))} style={iStyle} maxLength={10}/></div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Ad *</label><input value={newCurrency.name} onChange={e=>setNewCurrency(p=>({...p,name:e.target.value}))} style={iStyle}/></div>
                <div><label style={{fontSize:'0.78rem',color:'var(--text-tertiary)'}}>Sembol</label><input value={newCurrency.symbol} onChange={e=>setNewCurrency(p=>({...p,symbol:e.target.value}))} style={iStyle} maxLength={5} placeholder="$, €, £..."/></div>
              </div>
              <div style={{marginTop:12,display:'flex',gap:8}}>
                <button onClick={handleSaveCurrency} style={{padding:'7px 18px',background:'var(--accent-primary)',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',fontWeight:600}}>Ekle</button>
                <button onClick={()=>setShowAddCurrency(false)} style={{padding:'7px 18px',background:'none',border:'1px solid var(--border-secondary)',borderRadius:8,cursor:'pointer',color:'var(--text-secondary)'}}>İptal</button>
              </div>
            </div>
          )}

          <DataTable
            pageKey="exchange-currencies-list"
            data={currencies}
            rowKey="id"
            emptyText="Para birimi yok"
            columns={[
              { id: 'code', header: 'Kod', accessor: 'code', sortable: true, width: 90,
                cell: c => <span style={{fontWeight:700,color:'var(--accent-primary)',fontFamily:'monospace'}}>{c.code}</span> },
              { id: 'name', header: 'Ad', accessor: 'name', sortable: true,
                cell: c => c.name },
              { id: 'symbol', header: 'Sembol', accessor: 'symbol', sortable: true, width: 80,
                headerStyle: {textAlign:'center'}, cellStyle: {textAlign:'center',fontSize:'1.1rem'},
                cell: c => c.symbol || '-' },
              { id: 'is_local', header: 'Yerel PB', accessor: c => c.is_local ? 1 : 0, sortable: true, width: 100,
                headerStyle: {textAlign:'center'}, cellStyle: {textAlign:'center'},
                cell: c => c.is_local ? <span style={{color:'var(--success)',fontWeight:600}}>✓ Evet</span> : '-' },
              { id: 'status', header: 'Durum', accessor: c => c.is_active ? 'Aktif' : 'Pasif', sortable: true, width: 100,
                headerStyle: {textAlign:'center'}, cellStyle: {textAlign:'center'},
                cell: c => <span style={{fontSize:'0.72rem',padding:'2px 8px',borderRadius:4,background:c.is_active?'rgba(16,185,129,0.1)':'rgba(239,68,68,0.1)',color:c.is_active?'var(--success)':'var(--danger)'}}>{c.is_active?'Aktif':'Pasif'}</span> },
            ]}
          />
        </div>
      )}
    </div>
  );
}
export default ExchangePage;
